import {
    GET_CVDATA_REQUEST,
    GET_CVDATA_SUCCESS,
    GET_CVDATA_FAILURE,
} from './actions';

const initialState = {
    cvs: [],
    loading: false,
    error: null,
};

const cvsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CVDATA_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_CVDATA_SUCCESS:
            return {
                ...state,
                cvs: action.payload,
                loading: false,
                error: null,
            };
        case GET_CVDATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

export default cvsReducer;